<template lang="pug">
.location-field
  b-autocomplete(
    v-model="query"
    field="name"
    icon="map-marker"
    :data="results"
    :keep-first="true"
    @blur="blur"
    @input="input"
    @select="select"
  )
    template(slot-scope="props")
      b-icon(:icon="props.option.icon")
      span {{ props.option.name }}
      small.has-text-grey-light {{ props.option.formatted_address }}
  #google-map
</template>

<script>
/* global google */
import _ from 'lodash';
import { mapGetters } from 'vuex';
import maps from '@/utils/maps';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';

export default {
  name: 'event-location-field',
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
    }),
  },
  created() {
    if (this.value) {
      this.query = this.value;
    }
  },
  data() {
    return {
      placesService: null,
      query: null,
      results: [],
      settings: {
        searching: false,
      },
      stopSearching: null,
    };
  },
  methods: {
    blur() {
      setTimeout(() => {
        this.results = [];
      }, 250);
    },
    async input(val) {
      if (val && val.length > 3) {
        window.clearTimeout(this.stopSearching);
        const stop = () => {
          this.stopSearching = setTimeout(() => {
            this.settings.searching = false;
          }, 2000);
        };
        const payload = {
          fields: [
            'formatted_address',
            'icon',
            'id',
            'name',
          ],
          query: val,
        };
        return new Promise((resolve) => {
          this.placesService.textSearch(payload, (results, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              const options = results;
              options.map((p) => {
                p.icon = 'map-marker-plus';
                p.source = 'google';
                return p;
              });
              this.results = _.uniqBy(options.concat(this.results), 'place_id');
              stop();
              resolve(this.results);
            } else {
              stop();
              resolve(this.results);
            }
          });
        });
      }
      return Promise.resolve();
    },
    async select(selected) {
      if (selected) {
        const response = await this.$store.dispatch(actions.DO_GET_LOCATIONS, {
          google_place_id: selected.place_id,
        });
        if (response.record_count === 0) {
          this.placesService.getDetails({
            placeId: selected.place_id,
            fields: [
              'address_components',
              'formatted_address',
              'formatted_phone_number',
              'geometry',
              'name',
              'place_id',
              'website',
            ],
          }, this.saveLocation);
        } else {
          this.$emit('input', response.data.locations[0].id);
        }
      } else {
        this.$emit('input', null);
      }
    },
    async saveLocation(place, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        const address = maps.parseComponents(place.address_components);
        address.lat_lng = [place.geometry.location.lat(), place.geometry.location.lng()];
        const payload = {
          address,
          label: place.name,
          google_place_id: place.place_id,
          phone_number: place.formatted_phone_number,
          website: place.website,
        };
        this.query = place.name;
        const { data } = await this.$store.dispatch(actions.DO_CREATE_LOCATION, payload);
        this.$emit('input', data.locations[0].id);
      }
    },
  },
  mounted() {
    const map = new google.maps.Map(document.getElementById('google-map'));
    this.placesService = new google.maps.places.PlacesService(map);
  },
  props: {
    value: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/EventLocationField.vue